export default "__VITE_ASSET__aa483151__"